import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=7c14b1ae&scoped=true&"
import script from "./faq.vue?vue&type=script&lang=ts&"
export * from "./faq.vue?vue&type=script&lang=ts&"
import style0 from "./faq.vue?vue&type=style&index=0&id=7c14b1ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c14b1ae",
  null
  
)

export default component.exports